export { default } from './SearchScopeField';



// WEBPACK FOOTER //
// ./app/components/search/SearchScopeField/index.js